










import { Component } from 'vue-property-decorator';
import EntryTable from '@entries/components/tables/entry-table/entry-table.vue';
import Vue from 'vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';

@Component({
  name: 'bpc-entries',
  components: {
    'bpc-entry-table': EntryTable,
  },
})
export default class Entries extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get extendedFilterConfigName() {
    return this.accessControlConfig?.access_control_service === 'finddoc'
      ? 'extended-with-finddoc-sync'
      : 'extended';
  }
}
